// extracted by mini-css-extract-plugin
export default {"layout":"Container_layout__Yt3Ef"};